import WarningIconSVG from '../../../../components/svg/WarningTriangle.svg';

export const DuplicatePaylinkBanner = () => {
  return (
    <section
      className="mb-xl rounded-xs border border-core-65 p-l max-600:rounded-none max-600:p-xl max-600:text-center"
      data-testid="double-transaction-warning"
    >
      <div className="mb-l flex flex-row items-baseline text-m font-reg max-600:flex-col">
        <img
          src={WarningIconSVG}
          className="mr-l h-auto w-[30px] max-600:mx-auto max-600:mb-l max-600:mr-0"
          alt=""
        />
        <h2 className="m-0">You might have completed this payment before...</h2>
      </div>
      <p className="m-0 !mb-0 p-0 text-m font-reg">
        You have completed a payment very similar to this in the last 24 hours.
      </p>
      <p className="m-0 p-0 text-m font-reg">
        Please check before you continue.
      </p>
    </section>
  );
};
